import { atom } from "jotai";
import type { JwtPayload } from "jwt-decode";

// Extended user interface for complete user information
export interface ExtendedUserData {
  employeeId?: string;
  email?: string;
  pinnedItems?: string[];
  name?: string;
}

// Atom for mocked user data (used only in development)
export const MockUserData = atom<ExtendedUserData | null>(null);

// UserData atom that holds the effective user data (real or mocked)
export const UserData = atom<ExtendedUserData | null>(null);

// NOTE: All permissions can be obtained from this atom
// which returns an object that contains key in the pattern
// of can[Permission] (e.g. canCreateStep). The only exception
// to this is for Full Access which is just 'fullAccess'.
export type JwtExtendedPayload = JwtPayload & {
  permissions?: string[];
};
export const UserPermissions = atom<string[]>([]);
